import React from 'react';
import ReactDOM from 'react-dom';
import 'reflect-metadata';

import './index.css';

//import { WsSalesApp } from './SalesApp';

import { WsDeliverApp } from './DeliverApp';

import * as serviceWorker from './serviceWorker';

// import { runWithAdal } from 'react-adal';
// import { authContext } from './adalConfig';




import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";

import { msalInstance } from './authConfig';




import 'core-js/es/string/includes';

import { polyfill } from 'es6-promise';

(window as any).wsp = {
  env: {
    WSP_API_BASE_URL: `${process.env.REACT_APP_WSP_API_BASE_URL}`
  }
};

polyfill();




// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();

console.log(accounts);

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}




// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();




msalInstance.addEventCallback((event: EventMessage) => {
  // console.log('msalInstance.addEventCallback');

  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    // console.log('msalInstance.addEventCallback: EventType.LOGIN_SUCCESS');

    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});




ReactDOM.render(<WsDeliverApp pca={msalInstance} />, document.getElementById('root'));

serviceWorker.unregister();








// runWithAdal(authContext, () => {

//   ReactDOM.render(<App />, document.getElementById('root'));

//   // If you want your app to work offline and load faster, you can change
//   // unregister() to register() below. Note this comes with some pitfalls.
//   // Learn more about service workers: https://bit.ly/CRA-PWA
//   serviceWorker.unregister();

// }, true);
